module.exports = __webpack_public_path__ + "img/logo.3f4d7946.png";